import React from 'react';

const CountryBasedChatbotConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/country-based-routing',
			component: React.lazy(() => import('./CountryBasedChatbotSettings'))
		}
	]
};

export default CountryBasedChatbotConfig;
